/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React, { ComponentType } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentFarmerAccount } from '../features/azure-b2c/storage';

const withTfoAccess = <P extends object>(Component: ComponentType<P>) => {
  const WithTfoAccessComponent = (props: P) => {
    const account = useSelector(selectCurrentFarmerAccount);

    if (!account?.hasTfoAccess) {
      return null;
    }

    return <Component {...props} />;
  };

  // Assigning a display name to the returned component
  WithTfoAccessComponent.displayName = `withTfoAccess(${Component.displayName || Component.name})`;

  return WithTfoAccessComponent;
};

export default withTfoAccess;
